const newsletter = `
# eBL Newsletter 10

## 10 October 2022

### Fragmentarium

- Wildcards have been implemented in the search:? (any one sign); \\* (any sign
  or sequence of signs in a line); [a|b] (alternative signs, e.g. [bu|ba]).
- The signs ĝ and 0 are now allowed. The former should be used only in Sumerian
  texts (not in logograms). ĝ can be entered with Alt + g (Mac: Option + g).
- New shortcuts in text editor: Ctr +. (Mac: Command + .) = ... (U+2026 =
  Horizontal Ellipsis); Ctr + Shift + 2 = “”.
- It is now possible to download photos in the Fragmentarium (Download icon →
  Download Photo).

### Corpus

- The Corpus search now uses pagination and the display mode.
- Old Line numbers can now be indicated, e.g. in [SB Gilg I](https://www.ebl.lmu.de/corpus/L/1/4/SB/I).
  In order to import old line numbers, please send us an Excel table like
  [this one](https://docs.google.com/spreadsheets/d/1fAFA5YP6Yz3vpUl9R7T94pk3GFrdlsrg5Zo1WSQ_ugI/edit#gid=0).
- Omission of words in the corpus editions are now also marked as a variant (‡).
  All variants are now correctly marked.
- It is now possible to download editions as Word documents. At the moment only
  the reconstructed line, translation, and notes and parallels are exported.
  Export of the score transliteration of the manuscripts will be implemented
  soon.
- Corpus editions can be exported as ATF.

### Website launch

- We strive to open [http://www.ebl.lmu.de](http://www.ebl.lmu.de) to the public
  by the end of 2022.`

export default newsletter
